'use client';

import { forwardRef, Ref, useEffect, useRef, useState } from 'react';
import clsx from 'classnames';

import styles from './TextArea.module.scss';
import { TextAreaProps } from './types';

export const TextArea = forwardRef(
	(
		{ fullWidth = false, value, onChange, onBlur, hasError, className, ...props }: TextAreaProps,
		externalRef?: Ref<HTMLTextAreaElement>
	) => {
		const ref = useRef<HTMLTextAreaElement | null>(null);
		const [placeholder, setPlaceholder] = useState(props.placeholder || props.label || '');

		useEffect(() => {
			setPlaceholder(props.placeholder || props.label || '');
		}, [props.label, props.placeholder]);

		const containerClassNames = clsx(
			`TextArea`,
			styles.textAreaWrapper,
			{
				[styles.textAreaFullWidth]: !!fullWidth,
			},
			className
		);

		return (
			<div className={containerClassNames}>
				<div
					className={clsx(styles.textAreaInputWrapper, {
						[styles['textAreaInputWrapper--hasError']]: !!hasError,
					})}
				>
					<textarea
						ref={(refObject) => {
							ref.current = refObject;
							// @ts-ignore
							externalRef?.(refObject);
						}}
						className={styles.textAreaInputField}
						{...props}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
					/>
				</div>
			</div>
		);
	}
);

TextArea.displayName = 'TextArea';
